import type { NearbySuggestion } from "@contracts/nearbyLocations";

export function isRemaining(row: NearbySuggestion): boolean {
  return row.isVisible && (row.reviewStatus === "Pending" || row.reviewStatus === "Approved");
}

/** Only this list is accepted by onboarding/debug bulk import actions. Older rows are recommended. */
export function isInReviewList(row: NearbySuggestion): boolean {
  return isRemaining(row) && (row.tagKind === "Event" || row.recommendationTier !== "Additional" || row.reviewStatus === "Approved");
}

/** Good places kept beyond the initial shortlist, still waiting for an explicit choice. */
export function isAdditional(row: NearbySuggestion): boolean {
  return row.isVisible && row.tagKind === "Location" && row.recommendationTier === "Additional" && row.reviewStatus === "Pending";
}
